export const getAddressByZipCode = async ({ zipCode }) => {
  const normalizedZipCode = String(zipCode || '').replace(/\D/g, '')

  if (normalizedZipCode.length !== 8) {
    return { error: true }
  }

  try {
    const response = await fetch(
      `https://viacep.com.br/ws/${normalizedZipCode}/json/`
    )
    const data = await response.json()

    if (!response.ok || data?.erro) {
      return { error: true }
    }

    return {
      street: data.logradouro,
      district: data.bairro,
      city: data.localidade,
      cityCod: data.ibge,
      uf: data.uf,
      error: false
    }
  } catch (error) {
    return { error: true }
  }
}
